import React, { useEffect, useState } from "react";
import "./header.css";
import header_logo from "assets/header/logo.svg";
import header_arrow from "assets/header/header-arrow.svg";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isHoverVisible, setIsHoverVisible] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [subMenuItemOpen, setSubMenuItemOpen] = useState(false);
  const [featureLastSubMenuOpen, setFeatureLastSubMenuOpen] = useState(false);
  const [processLastSubMenuOpen, setProcessLastSubMenuOpen] = useState(false);
  const [inventoryLastSubMenuOpen, setInventoryLastSubMenuOpen] = useState(false);
  const [marketingLastSubMenuOpen, setMarketingLastSubMenuOpen] = useState(false);
  const [securityLastSubMenuOpen, setSecurityLastSubMenuOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".header-hover")) {
        setIsHoverVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let timeout;
    if (isHoverVisible) {
      timeout = setTimeout(() => {
        setIsHoverVisible(false);
      }, 2000);
    }
    return () => clearTimeout(timeout);
  }, [isHoverVisible]);

  const mobileNavShow = () => {
    setIsNavOpen((prev) => !prev);
  };
  const handleResponsive = () => {
    setIsMobile(window.innerWidth < 768);
    if (window.innerWidth >= 768) {
      setIsNavOpen(false);
    }
  };
  const handleLastSubMenuClick = () => {
    setIsNavOpen(false);
    setSubMenuItemOpen(false);
    setProcessLastSubMenuOpen(false);
    setInventoryLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResponsive);
    return () => {
      window.removeEventListener("resize", handleResponsive);
    };
  }, []);

  const featureSubMenuItem = () => {
    setSubMenuItemOpen((prevState) => !prevState);
  };

  const processManagement = (e) => {
    setInventoryLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
    e.stopPropagation();
    setProcessLastSubMenuOpen((prevState) => !prevState);
  };
  const inventoryManagement = (e) => {
    setProcessLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
    e.stopPropagation();
    setInventoryLastSubMenuOpen((prevState) => !prevState);
  };
  const marketingAutomation = (e) => {
    setProcessLastSubMenuOpen(false);
    setInventoryLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
    e.stopPropagation();
    setMarketingLastSubMenuOpen((prevState) => !prevState);
  };
  const securityMenu = (e) => {
    setProcessLastSubMenuOpen(false);
    setInventoryLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
    e.stopPropagation();
    setSecurityLastSubMenuOpen((prevState) => !prevState);
  };
  const featureLastSubMenu = (e) => {
    setProcessLastSubMenuOpen(false);
    setInventoryLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    e.stopPropagation();
    setFeatureLastSubMenuOpen((prevState) => !prevState);
  };
  useEffect(() => {
    setIsNavOpen(false);
    setSubMenuItemOpen(false);
    setProcessLastSubMenuOpen(false);
    setInventoryLastSubMenuOpen(false);
    setMarketingLastSubMenuOpen(false);
    setSecurityLastSubMenuOpen(false);
    setFeatureLastSubMenuOpen(false);
  }, [location]);

  return (
    <div className="header-container">
      <header className="container">
        <nav className="navbar">
          <Link to="../" className="logoOuter">
            <img className="logo" src={header_logo} alt="No header logo" />
          </Link>
          {isMobile && (
            <div className="mobile-menu--outer">
              <i className={isNavOpen ? "fa fa-times" : "fa fa-bars" } aria-hidden="true" onClick={mobileNavShow}></i>
            </div>
          )}
          <ul className={`nav-link ${isNavOpen ? "active" : ""}`}>
            <li>
              <Link to="../testimonial" onClick={() => setIsNavOpen(false)}>
                Customer
              </Link>
            </li>
            <li className="menu-item" onClick={featureSubMenuItem}>
              Features
              <i className={`fa fa-chevron-right mobile_arrow ${subMenuItemOpen ? "open" : ""}`}></i>
              <ul className={`sub-menu ${subMenuItemOpen ? "open" : ""}`}>
                <li className="sub-menu-item" onClick={featureLastSubMenu}>
                  Sales Automation
                  <i className={`fa fa-chevron-right mobile_arrow ${featureLastSubMenuOpen ? "open" : ""}`}></i>
                  <ul className={`last-sub-menu ${featureLastSubMenuOpen ? "open" : ""}`}>
                    <li>
                      <Link to="../sales-automation/lead-management" onClick={() => handleLastSubMenuClick()}>
                        Lead Management
                      </Link>
                    </li>
                    <li>
                      <Link to="../sales-automation/deal-management" onClick={() => handleLastSubMenuClick()}>
                        Deal Management
                      </Link>
                    </li>
                    <li>
                      <Link to="../sales-automation/contact-management" onClick={() => handleLastSubMenuClick()}>
                        Contact Management
                      </Link>
                    </li>
                    <li>
                      <Link to="../sales-automation/workflow-automation" onClick={() => handleLastSubMenuClick()}>
                        Workflow Automation
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="sub-menu-item" onClick={processManagement}>
                  Process Management
                  <i className={`fa fa-chevron-right mobile_arrow ${processLastSubMenuOpen ? "open" : ""}`}></i>
                  <ul className={`last-sub-menu ${processLastSubMenuOpen ? "open" : ""}`}>
                    <li>
                      <Link to="../process-management/approval-process" onClick={() => handleLastSubMenuClick()}>
                        Approval Process
                      </Link>
                    </li>
                    <li>
                      <Link to="../process-management/scoring-rules" onClick={() => handleLastSubMenuClick()}>
                        Scoring Rules
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="sub-menu-item" onClick={inventoryManagement}>
                  Inventory Management
                  <i className={`fa fa-chevron-right mobile_arrow ${inventoryLastSubMenuOpen ? "open" : ""}`}></i>
                  <ul className={`last-sub-menu ${inventoryLastSubMenuOpen ? "open" : ""}`}>
                    <li>
                      <Link to="../inventory-management/project-tower-unit" onClick={() => handleLastSubMenuClick()}>
                        Projects, Towers Units
                      </Link>
                    </li>
                    <li>
                      <Link to="../inventory-management/payment-schedule" onClick={() => handleLastSubMenuClick()}>
                        Payment Schedules
                      </Link>
                    </li>
                    <li>
                      <Link to="../inventory-management/offer-management" onClick={() => handleLastSubMenuClick()}>
                        Offer Management
                      </Link>
                    </li>
                    <li>
                      <Link to="../inventory-management/report-analytics" onClick={() => handleLastSubMenuClick()}>
                        Reporting & Analytics
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="sub-menu-item" onClick={marketingAutomation}>
                  Marketing Automation
                  <i className={`fa fa-chevron-right mobile_arrow ${marketingLastSubMenuOpen ? "open" : ""}`}></i>
                  <ul className={`last-sub-menu ${marketingLastSubMenuOpen ? "open" : ""}`}>
                    <li>
                      <Link to="../marketing-automation/marketing-attribution" onClick={() => handleLastSubMenuClick()}>
                        Marketing Attribution
                      </Link>
                    </li>
                    <li>
                      <Link to="../marketing-automation/bulk-marketing" onClick={() => handleLastSubMenuClick()}>
                        Bulk Marketing
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="sub-menu-item" onClick={securityMenu}>
                  Security
                  <i className={`fa fa-chevron-right mobile_arrow ${securityLastSubMenuOpen ? "open" : ""}`}></i>
                  <ul className={`last-sub-menu ${securityLastSubMenuOpen ? "open" : ""}`}>
                    <li>
                      <Link to="../security/roles-profiles-teams" onClick={() => handleLastSubMenuClick()}>
                        Roles, Profiles, Teams
                      </Link>
                    </li>
                    <li>
                      <Link to="../security/data-security-compliance" onClick={() => handleLastSubMenuClick()}>
                        Data Security & Compliance
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <Link to="../choose-plan" onClick={() => setIsNavOpen(false)}>
                Pricing
              </Link>
            </li>
            <li>
              <Link to="../contact-us" onClick={() => setIsNavOpen(false)}>
                Contact
              </Link>
            </li>
            <li className="mobile-view-only">
              <Link to="../privacy-policy" onClick={() => setIsNavOpen(false)}>
                Privacy Policy
              </Link>
            </li>
            <li className="mobile-view-only">
              <Link to="../term-and-condition" onClick={() => setIsNavOpen(false)}>
                Term and Condition
              </Link>
            </li>
            <Link className="register-button--header" to="../request-a-demo">
              <div className="right-login" onClick={() => setIsNavOpen(false)}>
                <button className="login-btn">GET A DEMO</button>
                <div className="header-arrow">
                  <img src={header_arrow} alt="No arrow" />
                </div>
              </div>
            </Link>
          </ul>
        </nav>
      </header>
    </div>
  );
};

export default Header;
